import classNames from "classnames";

import { CartProductSize, Size } from "@/api/generatedTypes";

import { PopupContainer } from "../PopupContainer";
import styles from "../PopupContainer/PopupSharedStyles.module.scss";

interface PopupProductSizesProps {
  isSizesPopupOpen: boolean;
  closeSizesPopup(): void;
  sizes: Size[];
  chooseSizeHandler: (size: Size) => () => void;
  choosenSize?: Size | Size[] | CartProductSize | CartProductSize[];
  sizesPopupClassName?: string;
}

const PopupProductSizes = ({
  isSizesPopupOpen,
  closeSizesPopup,
  sizes,
  chooseSizeHandler,
  choosenSize,
  sizesPopupClassName = "",
}: PopupProductSizesProps) => {
  return (
    <PopupContainer
      className={styles.popupContainer}
      isOpen={isSizesPopupOpen}
      close={closeSizesPopup}
    >
      <div className={classNames(styles.sizesPopup, sizesPopupClassName)}>
        {sizes.map((size) => {
          const isCheckmark = Array.isArray(choosenSize)
            ? choosenSize.find((item) => item.id === size.id)
            : size.id === choosenSize?.id;

          return (
            <button
              key={size.id}
              className={classNames(styles.sizeItem)}
              onClick={chooseSizeHandler(size)}
              disabled={!size.count_online}
            >
              {size.size}
              {isCheckmark && (
                <img
                  className={styles.checkmark}
                  src="/static/img/icons-v6/checkmark-black.svg"
                  alt="checkmark icon"
                />
              )}
            </button>
          );
        })}
      </div>
    </PopupContainer>
  );
};

export default PopupProductSizes;
